import { render } from "./base-upload.vue?vue&type=template&id=b521d97a&ts=true"
import script from "./base-upload.vue?vue&type=script&lang=ts"
export * from "./base-upload.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__